import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="136"
      height="48"
      viewBox="0 0 352 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9157 128C13.5308 128 16.1458 128 18.7608 128C123.587 128 228.413 128 333.239 128C335.854 128 338.469 128 341.084 128C342.589 128 344.094 128 345.598 128C346.103 128.001 346.59 127.944 347.081 127.827C347.316 127.77 347.548 127.7 347.776 127.618C348.696 127.284 349.448 126.806 350.139 126.11C350.236 126.013 350.329 125.912 350.419 125.809C350.534 125.678 350.643 125.542 350.746 125.402C350.753 125.392 350.761 125.382 350.768 125.372C351.015 125.033 351.225 124.679 351.401 124.299C351.409 124.283 351.416 124.266 351.424 124.249C351.432 124.232 351.439 124.215 351.447 124.198C351.455 124.182 351.462 124.164 351.469 124.147C351.491 124.096 351.513 124.044 351.534 123.993C351.538 123.981 351.544 123.968 351.549 123.956C351.645 123.712 351.725 123.465 351.792 123.212C351.794 123.203 351.796 123.195 351.799 123.186C351.932 122.662 351.998 122.141 351.998 121.6C351.998 117.333 351.998 113.067 351.998 108.799C351.998 74.6665 351.998 40.5336 351.998 6.40019C351.998 2.86566 349.133 0 345.598 0C344.094 0 342.589 0 341.084 0C339.869 0 338.654 0 337.439 0C337.405 0 337.372 0 337.337 0C337.287 0 337.238 0 337.188 0C335.871 0 334.554 0 333.238 0C228.412 0 123.585 0 18.7603 0C17.4435 0 16.1272 0 14.8109 0C14.7613 0 14.711 0 14.6613 0C14.6275 0 14.5936 0 14.5592 0C13.3445 0 12.1292 0 10.9146 0C9.40975 0 7.90499 0 6.40019 0C2.86566 0 0 2.86566 0 6.40019C0 40.5336 0 74.6665 0 108.799C0 113.067 0 117.333 0 121.6C0 125.134 2.86566 128 6.40019 128C7.90612 128 9.41092 128 10.9157 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M132.257 19.5996C132.077 19.5996 132.001 19.6747 132.001 19.8564C132.001 49.2858 132.001 78.7146 132.001 108.144C132.001 108.325 132.077 108.4 132.257 108.4C161.687 108.4 191.115 108.4 220.545 108.4C220.727 108.4 220.801 108.325 220.801 108.144C220.801 78.7146 220.801 49.2858 220.801 19.8564C220.801 19.6747 220.727 19.5996 220.545 19.5996C191.115 19.5996 161.687 19.5996 132.257 19.5996Z"
        fill="#575756"
      />
      <path
        d="M220.145 20.2554V19.9998H132.658"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M220.145 19.9998C220.326 19.9998 220.401 20.0748 220.401 20.2554C220.401 49.419 220.401 78.5809 220.401 107.744C220.401 107.924 220.326 108 220.145 108C190.982 108 161.82 108 132.658 108C132.477 108 132.402 107.924 132.402 107.744C132.402 78.5814 132.402 49.419 132.402 20.2554C132.402 20.0748 132.477 19.9998 132.658 19.9998"
        fill="#E3E3E3"
      />
      <path
        d="M220.401 107.744C220.401 107.925 220.326 108 220.146 108C190.983 108 161.821 108 132.658 108C132.477 108 132.402 107.925 132.402 107.744C132.402 78.5814 132.402 49.4188 132.402 20.2557C132.402 20.0751 132.477 20 132.658 20C161.821 20 190.983 20 220.146 20C220.326 20 220.401 20.0751 220.401 20.2557C220.401 49.4188 220.401 78.5814 220.401 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M132.256 108.4C132.075 108.4 132 108.325 132 108.145C132 78.7153 132 49.286 132 19.8566C132 19.676 132.075 19.6008 132.256 19.6008C161.685 19.6008 191.114 19.6008 220.543 19.6008C220.724 19.6008 220.799 19.676 220.799 19.8566C220.799 49.286 220.799 78.7153 220.799 108.145C220.799 108.325 220.724 108.4 220.543 108.4C191.114 108.4 161.685 108.4 132.256 108.4Z"
        fill="#575756"
      />
      <path
        d="M132.4 20.2567C132.4 49.4191 132.4 78.5821 132.4 107.744C132.4 107.925 132.475 108 132.656 108C161.818 108 190.981 108 220.143 108C220.324 108 220.399 107.925 220.399 107.744C220.399 78.5821 220.399 49.4191 220.399 20.2567C220.399 20.0761 220.324 20.001 220.143 20.001C190.981 20.001 161.818 20.001 132.656 20.001C132.475 20.0004 132.4 20.0756 132.4 20.2567Z"
        fill="#E3E3E3"
      />
      <path
        d="M173.343 75.1205C173.524 75.1205 173.599 75.0453 173.599 74.8647C173.599 67.6218 173.599 60.3795 173.599 53.1366C173.599 52.956 173.524 52.8809 173.343 52.8809C164.25 52.8809 155.156 52.8809 146.064 52.8809C145.883 52.8809 145.808 52.956 145.808 53.1366C145.808 60.3795 145.808 67.6218 145.808 74.8647C145.808 75.0453 145.883 75.1205 146.064 75.1205C155.156 75.1205 164.25 75.1205 173.343 75.1205Z"
        fill="#575756"
      />
      <path
        d="M146.464 74.7201C146.282 74.7201 146.207 74.6449 146.207 74.4643C146.207 67.4884 146.207 60.5119 146.207 53.5366C146.207 53.3554 146.282 53.2803 146.464 53.2803C155.29 53.2803 164.117 53.2803 172.943 53.2803C173.124 53.2803 173.199 53.3554 173.199 53.5366C173.199 60.5119 173.199 67.4884 173.199 74.4643C173.199 74.6449 173.124 74.7201 172.943 74.7201C164.117 74.7201 155.29 74.7201 146.464 74.7201Z"
        fill="#E3E3E3"
      />
      <path
        d="M148.99 89.8122C148.99 90.152 148.85 90.293 148.51 90.293C148.296 90.293 148.083 90.293 147.871 90.293C147.871 91.156 147.871 92.0208 147.871 92.8838C149.75 92.8838 151.631 92.8838 153.511 92.8838C153.85 92.8838 153.991 93.025 153.991 93.3648C153.991 93.7046 153.85 93.8445 153.511 93.8445C152.842 93.8445 152.173 93.8445 151.504 93.8445C151.504 94.7075 151.504 95.5723 151.504 96.4353C151.717 96.4353 151.93 96.4353 152.144 96.4353C152.483 96.4353 152.623 96.5753 152.623 96.9151C152.623 97.2448 152.623 97.5744 152.623 97.904C152.623 98.2438 152.483 98.3849 152.144 98.3849C151.397 98.3849 150.651 98.3849 149.904 98.3849C149.565 98.3849 149.425 98.2438 149.425 97.904C149.425 97.5744 149.425 97.2448 149.425 96.9151C149.425 96.5753 149.565 96.4353 149.904 96.4353C150.117 96.4353 150.331 96.4353 150.544 96.4353C150.544 95.5723 150.544 94.7075 150.544 93.8445C148.441 93.8445 146.339 93.8445 144.237 93.8445C144.237 94.7075 144.237 95.5723 144.237 96.4353C144.45 96.4353 144.662 96.4353 144.876 96.4353C145.216 96.4353 145.356 96.5753 145.356 96.9151C145.356 97.2448 145.356 97.5744 145.356 97.904C145.356 98.2438 145.216 98.3849 144.876 98.3849C144.13 98.3849 143.383 98.3849 142.637 98.3849C142.297 98.3849 142.157 98.2438 142.157 97.904C142.157 97.5744 142.157 97.2448 142.157 96.9151C142.157 96.5753 142.297 96.4353 142.637 96.4353C142.85 96.4353 143.064 96.4353 143.277 96.4353C143.277 95.5723 143.277 94.7075 143.277 93.8445C142.607 93.8445 141.938 93.8445 141.269 93.8445C140.929 93.8445 140.789 93.7046 140.789 93.3648C140.789 93.025 140.929 92.8838 141.269 92.8838C143.15 92.8838 145.029 92.8838 146.91 92.8838C146.91 92.0208 146.91 91.156 146.91 90.293C146.697 90.293 146.483 90.293 146.27 90.293C145.931 90.293 145.791 90.152 145.791 89.8122C145.791 89.4826 145.791 89.1528 145.791 88.8232C145.791 88.4834 145.931 88.3435 146.27 88.3435C147.017 88.3435 147.763 88.3435 148.51 88.3435C148.849 88.3435 148.989 88.4834 148.989 88.8232C148.99 89.1528 148.99 89.4826 148.99 89.8122Z"
        fill="#575756"
      />
      <path
        d="M150.103 59.5205V70.5608H169.304V59.5205H164.903V57.1203H163.303V55.2002H156.103V57.1203H154.504V59.5205H150.103Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.383 55.2803H153.703V57.3597H149.383V55.2803Z"
        fill="#C6C6C6"
      />
      <path
        d="M165.703 55.2803H170.023V57.3597H165.703V55.2803Z"
        fill="#C6C6C6"
      />
      <path d="M165.703 70.5608V68.4802H164.939V70.5608" fill="#CA9E67" />
      <path d="M163.98 70.5608V68.4802H163.334V70.5608" fill="#CA9E67" />
      <path d="M162.374 70.5608V68.4802H161.728V70.5608" fill="#CA9E67" />
      <path d="M160.768 70.5608V68.4802H160.122V70.5608" fill="#CA9E67" />
      <path d="M159.161 70.5608V68.4802H158.515V70.5608" fill="#CA9E67" />
      <path d="M157.555 70.5608V68.4802H156.909V70.5608" fill="#CA9E67" />
      <path d="M155.949 70.5608V68.4802H155.303V70.5608" fill="#CA9E67" />
      <path d="M154.343 70.5608V68.4802H153.703V70.5608" fill="#CA9E67" />
      <path
        d="M210.083 99.2511C210.667 99.2511 211.141 98.7778 211.141 98.1939C211.141 97.61 210.667 97.1367 210.083 97.1367C209.499 97.1367 209.026 97.61 209.026 98.1939C209.026 98.7778 209.499 99.2511 210.083 99.2511Z"
        fill="#575756"
      />
      <path
        d="M209.759 95.5366C210.137 95.5366 210.366 95.1212 210.165 94.8006C209.904 94.3852 209.577 94.5618 209.223 94.62C208.498 94.7391 207.951 95.0236 207.432 95.5417C206.913 96.061 206.63 96.608 206.51 97.3322C206.452 97.6861 206.275 98.0146 206.691 98.2759C207.011 98.4763 207.427 98.2471 207.427 97.869C207.428 96.5809 208.472 95.5383 209.759 95.5366Z"
        fill="#575756"
      />
      <path
        d="M209.759 92.9769C210.399 92.9769 210.381 92.0151 209.741 92.0173C209.225 92.0185 208.731 92.084 208.232 92.2189C207.197 92.4983 206.382 92.9741 205.623 93.7315C204.865 94.4902 204.389 95.3058 204.108 96.341C203.973 96.84 203.908 97.335 203.906 97.8515C203.904 98.4915 204.866 98.5096 204.866 97.869C204.866 95.1709 207.061 92.9769 209.759 92.9769Z"
        fill="#575756"
      />
      <path
        d="M209.759 90.4165C210.114 90.4165 210.259 90.2641 210.238 89.9096C210.201 89.2577 209.677 89.4457 209.239 89.4728C208.555 89.5145 207.902 89.6341 207.248 89.839C205.897 90.2624 204.814 90.9228 203.814 91.923C202.813 92.9232 202.153 94.0057 201.73 95.3576C201.525 96.0101 201.405 96.6643 201.363 97.3473C201.336 97.7858 201.147 98.3108 201.799 98.3481C202.154 98.3678 202.306 98.2244 202.306 97.8682C202.306 93.7591 205.65 90.4165 209.759 90.4165Z"
        fill="#575756"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.666 0.0012207 108.799C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.86631 127.999 6.40196 127.999C7.90676 127.999 9.41159 127.999 10.9164 127.999C13.5314 127.999 16.1465 127.999 18.761 127.999C48.9213 127.999 191.08 127.999 221.24 127.999C223.856 127.999 338.47 127.999 341.085 127.999C342.59 127.999 344.095 127.999 345.6 127.999C346.104 128.001 346.591 127.943 347.081 127.826C347.318 127.77 347.549 127.7 347.777 127.618C348.697 127.284 349.45 126.805 350.139 126.11C350.236 126.013 350.33 125.912 350.42 125.809C350.849 125.318 351.185 124.793 351.448 124.198C351.456 124.182 351.463 124.164 351.471 124.147C351.602 123.842 351.709 123.532 351.793 123.211C351.795 123.202 351.797 123.194 351.799 123.185C351.934 122.661 351.999 122.14 351.999 121.599C351.999 117.332 351.999 113.066 351.999 108.799C351.999 108.666 351.999 108.532 351.999 108.399H0.0012207V108.4Z"
        fill="url(#paint0_linear_6152_24427)"
      />
      <path
        opacity="0.2"
        d="M19.6007 0C19.3207 0 19.0408 0 18.7608 0C17.4445 0 16.1277 0 14.8114 0C14.7618 0 14.7115 0 14.6618 0C14.628 0 14.5941 0 14.5602 0C13.345 0 12.1298 0 10.9151 0C9.41031 0 7.90548 0 6.40068 0C2.86559 0 0.000488281 2.86566 0.000488281 6.40019C0.000488281 40.5336 0.000488281 74.666 0.000488281 108.799C0.000488281 113.067 0.000488281 117.333 0.000488281 121.6C0.000488281 125.134 2.86559 127.999 6.40068 127.999C7.90548 127.999 9.41031 127.999 10.9151 127.999C13.5302 127.999 16.1457 127.999 18.7602 127.999C19.0402 127.999 19.3202 127.999 19.6001 127.999V0H19.6007Z"
        fill="url(#paint1_linear_6152_24427)"
      />
      <path
        opacity="0.2"
        d="M332.399 0C332.679 0 332.959 0 333.239 0C334.556 0 335.872 0 337.189 0C337.238 0 337.288 0 337.338 0C337.372 0 337.406 0 337.44 0C338.655 0 339.87 0 341.085 0C342.59 0 344.095 0 345.599 0C349.134 0 351.999 2.86566 351.999 6.40019C351.999 40.5336 351.999 74.666 351.999 108.799C351.999 113.067 351.999 117.333 351.999 121.6C351.999 125.134 349.134 127.999 345.599 127.999C344.095 127.999 342.59 127.999 341.085 127.999C338.47 127.999 335.854 127.999 333.239 127.999C332.959 127.999 332.68 127.999 332.4 127.999V0H332.399Z"
        fill="url(#paint2_linear_6152_24427)"
      />
      <path
        d="M19.8565 19.5996C19.6759 19.5996 19.6008 19.6747 19.6008 19.8564C19.6008 49.2858 19.6008 78.7146 19.6008 108.144C19.6008 108.325 19.6759 108.4 19.8565 108.4C49.2859 108.4 78.7148 108.4 108.144 108.4C108.326 108.4 108.4 108.325 108.4 108.144C108.4 78.7146 108.4 49.2858 108.4 19.8564C108.4 19.6747 108.326 19.5996 108.144 19.5996C78.7148 19.5996 49.2859 19.5996 19.8565 19.5996Z"
        fill="#575756"
      />
      <path
        d="M107.745 20.2554V19.9998H20.2573"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.745 19.9998C107.925 19.9998 108 20.0748 108 20.2554C108 49.419 108 78.5809 108 107.744C108 107.924 107.925 108 107.745 108C78.5818 108 49.4193 108 20.2569 108C20.0763 108 20.0012 107.924 20.0012 107.744C20.0012 78.5814 20.0012 49.419 20.0012 20.2554C20.0012 20.0748 20.0763 19.9998 20.2569 19.9998"
        fill="#E3E3E3"
      />
      <path
        d="M108.001 107.744C108.001 107.925 107.926 108 107.745 108C78.5825 108 49.4199 108 20.2574 108C20.0768 108 20.0017 107.925 20.0017 107.744C20.0017 78.5814 20.0017 49.4188 20.0017 20.2557C20.0017 20.0751 20.0768 20 20.2574 20C49.4199 20 78.5825 20 107.745 20C107.926 20 108.001 20.0751 108.001 20.2557C108.001 49.4188 108.001 78.5814 108.001 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M19.8549 108.4C19.6743 108.4 19.5993 108.325 19.5993 108.145C19.5993 78.7153 19.5993 49.286 19.5993 19.8566C19.5993 19.676 19.6743 19.6008 19.8549 19.6008C49.2843 19.6008 78.7131 19.6008 108.143 19.6008C108.323 19.6008 108.398 19.676 108.398 19.8566C108.398 49.286 108.398 78.7153 108.398 108.145C108.398 108.325 108.323 108.4 108.143 108.4C78.7131 108.4 49.2843 108.4 19.8549 108.4Z"
        fill="#575756"
      />
      <path
        d="M19.9995 20.2567C19.9995 49.4191 19.9995 78.5821 19.9995 107.744C19.9995 107.925 20.0746 108 20.2552 108C49.4176 108 78.58 108 107.742 108C107.923 108 107.998 107.925 107.998 107.744C107.998 78.5821 107.998 49.4191 107.998 20.2567C107.998 20.0761 107.923 20.001 107.742 20.001C78.58 20.001 49.4176 20.001 20.2552 20.001C20.0746 20.0004 19.9995 20.0756 19.9995 20.2567Z"
        fill="#E3E3E3"
      />
      <path
        d="M63.5 93.0006C47.7852 93.0006 35 80.2155 35 64.5C35 48.7846 47.7855 35.9998 63.5 35.9998C79.2144 35.9998 91.9999 48.7849 91.9999 64.5C91.9999 80.2151 79.2148 93.0006 63.5 93.0006Z"
        fill="#E3E3E3"
      />
      <path
        d="M63.5001 91.8916C48.3969 91.8916 36.1091 79.6035 36.1091 64.5C36.1091 49.3964 48.3969 37.1086 63.5001 37.1086C78.6037 37.1086 90.8911 49.3964 90.8911 64.5C90.8911 79.6035 78.6037 91.8916 63.5001 91.8916Z"
        fill="#3C3C3B"
      />
      <path
        d="M63.5001 37.4429C48.5809 37.4429 36.4431 49.5807 36.4431 64.5002C36.4431 79.4197 48.5809 91.5576 63.5001 91.5576C78.4193 91.5576 90.5571 79.4197 90.5571 64.5002C90.5571 49.5807 78.4193 37.4429 63.5001 37.4429Z"
        fill="#E3E3E3"
      />
      <path
        d="M63.4999 90.3221C77.761 90.3221 89.3219 78.7613 89.3219 64.5002C89.3219 50.2391 77.761 38.6782 63.4999 38.6782C49.2388 38.6782 37.678 50.2391 37.678 64.5002C37.678 78.7613 49.2388 90.3221 63.4999 90.3221Z"
        fill="url(#paint3_linear_6152_24427)"
      />
      <path
        d="M63.4999 90.3221C77.761 90.3221 89.3219 78.7613 89.3219 64.5002C89.3219 50.2391 77.761 38.6782 63.4999 38.6782C49.2388 38.6782 37.678 50.2391 37.678 64.5002C37.678 78.7613 49.2388 90.3221 63.4999 90.3221Z"
        fill="url(#paint4_radial_6152_24427)"
      />
      <path
        d="M63.5 88.3008C76.6448 88.3008 87.3008 77.6448 87.3008 64.5C87.3008 51.3552 76.6448 40.6992 63.5 40.6992C50.3552 40.6992 39.6992 51.3552 39.6992 64.5C39.6992 77.6448 50.3552 88.3008 63.5 88.3008Z"
        fill="url(#paint5_radial_6152_24427)"
      />
      <path
        d="M63.5003 84.7447C74.6812 84.7447 83.7451 75.6808 83.7451 64.4999C83.7451 53.319 74.6812 44.2551 63.5003 44.2551C52.3194 44.2551 43.2556 53.319 43.2556 64.4999C43.2556 75.6808 52.3194 84.7447 63.5003 84.7447Z"
        fill="url(#paint6_radial_6152_24427)"
      />
      <path
        d="M63.5001 81.7203C73.0105 81.7203 80.7203 74.0106 80.7203 64.5001C80.7203 54.9897 73.0105 47.28 63.5001 47.28C53.9897 47.28 46.28 54.9897 46.28 64.5001C46.28 74.0106 53.9897 81.7203 63.5001 81.7203Z"
        fill="url(#paint7_radial_6152_24427)"
      />
      <path
        d="M63.5 67.5983C65.2113 67.5983 66.5985 66.2111 66.5985 64.4998C66.5985 62.7886 65.2113 61.4014 63.5 61.4014C61.7888 61.4014 60.4016 62.7886 60.4016 64.4998C60.4016 66.2111 61.7888 67.5983 63.5 67.5983Z"
        fill="#3C3C3B"
      />
      <path
        d="M55.7332 39.8689C55.4664 39.9529 55.2041 40.0444 54.9414 40.137C55.0238 40.1857 55.1189 40.2159 55.2215 40.2159C55.4538 40.2159 55.6518 40.072 55.7332 39.8689Z"
        fill="#3C3C3B"
      />
      <path
        d="M56.8779 40.216C57.1824 40.216 57.4298 39.9689 57.4298 39.6644C57.4298 39.575 57.4067 39.492 57.369 39.4172C57.0192 39.5025 56.6732 39.5959 56.3291 39.6954C56.3456 39.985 56.5838 40.216 56.8779 40.216Z"
        fill="#3C3C3B"
      />
      <path
        d="M57.9814 39.664C57.9814 39.9685 58.2283 40.2157 58.5328 40.2157C58.8379 40.2157 59.0854 39.9685 59.0854 39.664C59.0854 39.4103 58.913 39.1989 58.6795 39.1343C58.5204 39.1644 58.3607 39.1916 58.2026 39.2243C58.0695 39.3253 57.9814 39.4838 57.9814 39.664Z"
        fill="#3C3C3B"
      />
      <path
        d="M60.1888 40.2156C60.4935 40.2156 60.7405 39.9686 60.7405 39.6639C60.7405 39.3593 60.4935 39.1123 60.1888 39.1123C59.8842 39.1123 59.6372 39.3593 59.6372 39.6639C59.6372 39.9686 59.8842 40.2156 60.1888 40.2156Z"
        fill="#3C3C3B"
      />
      <path
        d="M61.8454 40.2159C62.1496 40.2159 62.3967 39.9688 62.3967 39.6643C62.3967 39.3594 62.1496 39.1123 61.8454 39.1123C61.5399 39.1123 61.2935 39.3591 61.2935 39.6643C61.2931 39.9688 61.5399 40.2159 61.8454 40.2159Z"
        fill="#3C3C3B"
      />
      <path
        d="M63.5006 40.2156C63.8053 40.2156 64.0523 39.9686 64.0523 39.6639C64.0523 39.3593 63.8053 39.1123 63.5006 39.1123C63.1959 39.1123 62.949 39.3593 62.949 39.6639C62.949 39.9686 63.1959 40.2156 63.5006 40.2156Z"
        fill="#3C3C3B"
      />
      <path
        d="M65.1561 40.2156C65.4608 40.2156 65.7077 39.9686 65.7077 39.6639C65.7077 39.3593 65.4608 39.1123 65.1561 39.1123C64.8515 39.1123 64.6045 39.3593 64.6045 39.6639C64.6045 39.9686 64.8515 40.2156 65.1561 40.2156Z"
        fill="#3C3C3B"
      />
      <path
        d="M66.8124 40.2156C67.117 40.2156 67.364 39.9686 67.364 39.6639C67.364 39.3593 67.117 39.1123 66.8124 39.1123C66.5077 39.1123 66.2607 39.3593 66.2607 39.6639C66.2607 39.9686 66.5077 40.2156 66.8124 40.2156Z"
        fill="#3C3C3B"
      />
      <path
        d="M67.9158 39.664C67.9158 39.9685 68.163 40.2157 68.4681 40.2157C68.7726 40.2157 69.02 39.9685 69.02 39.664C69.02 39.4838 68.9323 39.3253 68.7986 39.2246C68.6404 39.1916 68.4804 39.1644 68.3213 39.1343C68.0881 39.1992 67.9158 39.4106 67.9158 39.664Z"
        fill="#3C3C3B"
      />
      <path
        d="M70.1235 40.216C70.4181 40.216 70.6561 39.985 70.6722 39.6954C70.3281 39.5963 69.9821 39.5025 69.6323 39.4172C69.5946 39.4917 69.5715 39.575 69.5715 39.6644C69.5715 39.9689 69.8193 40.216 70.1235 40.216Z"
        fill="#3C3C3B"
      />
      <path
        d="M71.7795 40.2158C71.8822 40.2158 71.9769 40.1857 72.0593 40.1369C71.797 40.0447 71.5343 39.9531 71.2678 39.8691C71.3496 40.0719 71.5473 40.2158 71.7795 40.2158Z"
        fill="#3C3C3B"
      />
      <path
        d="M51.9108 41.8714C52.2153 41.8714 52.4628 41.6246 52.4628 41.3198C52.4628 41.2656 52.4527 41.2143 52.4381 41.1646C52.1117 41.3195 51.7904 41.4833 51.4717 41.6512C51.5728 41.7843 51.7309 41.8714 51.9108 41.8714Z"
        fill="#3C3C3B"
      />
      <path
        d="M53.5661 41.8717C53.8709 41.8717 54.1181 41.6246 54.1181 41.3198C54.1181 41.0149 53.8709 40.7678 53.5661 40.7678C53.2613 40.7678 53.0142 41.0149 53.0142 41.3198C53.0142 41.6246 53.2613 41.8717 53.5661 41.8717Z"
        fill="#3C3C3B"
      />
      <path
        d="M55.2216 41.8717C55.5264 41.8717 55.7735 41.6246 55.7735 41.3198C55.7735 41.0149 55.5264 40.7678 55.2216 40.7678C54.9168 40.7678 54.6697 41.0149 54.6697 41.3198C54.6697 41.6246 54.9168 41.8717 55.2216 41.8717Z"
        fill="#3C3C3B"
      />
      <path
        d="M57.4298 41.3201C57.4298 41.015 57.1824 40.7678 56.8779 40.7678C56.5734 40.7678 56.3259 41.015 56.3259 41.3201C56.3259 41.4896 56.4039 41.6391 56.5243 41.7402C56.8136 41.6515 57.106 41.5691 57.4 41.4915C57.4178 41.4373 57.4298 41.38 57.4298 41.3201Z"
        fill="#3C3C3B"
      />
      <path
        d="M58.5328 40.7678C58.2283 40.7678 57.9814 41.015 57.9814 41.3201C57.9814 41.3299 57.984 41.3388 57.9843 41.3483C58.3357 41.2649 58.6899 41.1886 59.047 41.1211C58.9672 40.9145 58.7675 40.7678 58.5328 40.7678Z"
        fill="#3C3C3B"
      />
      <path
        d="M60.1887 40.7678C60.0049 40.7678 59.843 40.8587 59.7429 40.9969C60.004 40.9554 60.2676 40.9227 60.5313 40.8898C60.4368 40.8144 60.3189 40.7678 60.1887 40.7678Z"
        fill="#3C3C3B"
      />
      <path
        d="M66.8124 40.7678C66.6822 40.7678 66.5646 40.8144 66.4702 40.8898C66.7338 40.9227 66.9972 40.9554 67.2579 40.9969C67.1578 40.8584 66.9962 40.7678 66.8124 40.7678Z"
        fill="#3C3C3B"
      />
      <path
        d="M69.0202 41.3201C69.0202 41.015 68.7728 40.7678 68.4683 40.7678C68.2338 40.7678 68.0345 40.9145 67.9543 41.1211C68.3118 41.1886 68.6657 41.2649 69.0171 41.3486C69.0177 41.3388 69.0202 41.3296 69.0202 41.3201Z"
        fill="#3C3C3B"
      />
      <path
        d="M70.6756 41.3201C70.6756 41.015 70.4288 40.7678 70.1237 40.7678C69.8192 40.7678 69.5718 41.015 69.5718 41.3201C69.5718 41.3803 69.5838 41.4373 69.6019 41.4918C69.8962 41.5694 70.1883 41.6518 70.4779 41.7406C70.5977 41.6388 70.6756 41.4893 70.6756 41.3201Z"
        fill="#3C3C3B"
      />
      <path
        d="M71.7795 41.8717C72.0843 41.8717 72.3314 41.6246 72.3314 41.3198C72.3314 41.0149 72.0843 40.7678 71.7795 40.7678C71.4746 40.7678 71.2275 41.0149 71.2275 41.3198C71.2275 41.6246 71.4746 41.8717 71.7795 41.8717Z"
        fill="#3C3C3B"
      />
      <path
        d="M73.4353 41.8717C73.7401 41.8717 73.9872 41.6246 73.9872 41.3198C73.9872 41.0149 73.7401 40.7678 73.4353 40.7678C73.1305 40.7678 72.8833 41.0149 72.8833 41.3198C72.8833 41.6246 73.1305 41.8717 73.4353 41.8717Z"
        fill="#3C3C3B"
      />
      <path
        d="M75.0903 41.8715C75.2703 41.8715 75.4284 41.7844 75.5295 41.6517C75.211 41.4837 74.89 41.3202 74.564 41.1653C74.5494 41.2147 74.5393 41.266 74.5393 41.3202C74.5393 41.6247 74.7858 41.8715 75.0903 41.8715Z"
        fill="#3C3C3B"
      />
      <path
        d="M49.1448 43.0359C48.916 43.1892 48.6929 43.3502 48.4692 43.5105C48.5111 43.5207 48.5541 43.5276 48.5988 43.5276C48.8833 43.5276 49.1144 43.3122 49.1448 43.0359Z"
        fill="#3C3C3B"
      />
      <path
        d="M49.7026 42.9753C49.7026 43.2801 49.9501 43.5276 50.2546 43.5276C50.5591 43.5276 50.8062 43.2804 50.8062 42.9753C50.8062 42.6708 50.5591 42.4233 50.2546 42.4233C50.1579 42.4233 50.0689 42.4503 49.99 42.494C49.9675 42.5079 49.9454 42.5228 49.9229 42.5371C49.7901 42.6378 49.7026 42.7956 49.7026 42.9753Z"
        fill="#3C3C3B"
      />
      <path
        d="M51.9108 43.5272C52.2157 43.5272 52.4628 43.2801 52.4628 42.9753C52.4628 42.6705 52.2157 42.4233 51.9108 42.4233C51.606 42.4233 51.3589 42.6705 51.3589 42.9753C51.3589 43.2801 51.606 43.5272 51.9108 43.5272Z"
        fill="#3C3C3B"
      />
      <path
        d="M53.566 42.4233C53.2612 42.4233 53.0146 42.6708 53.0146 42.9753C53.0146 43.026 53.0236 43.0738 53.0362 43.1204C53.3607 42.9614 53.6899 42.8102 54.0229 42.6654C53.9237 42.5193 53.7561 42.4233 53.566 42.4233Z"
        fill="#3C3C3B"
      />
      <path
        d="M73.9871 42.9753C73.9871 42.6708 73.7394 42.4233 73.4352 42.4233C73.2448 42.4233 73.0774 42.5193 72.9783 42.6657C73.3113 42.8105 73.6405 42.9617 73.9653 43.1207C73.9779 43.0741 73.9871 43.026 73.9871 42.9753Z"
        fill="#3C3C3B"
      />
      <path
        d="M75.0903 43.5272C75.3951 43.5272 75.6422 43.2801 75.6422 42.9753C75.6422 42.6705 75.3951 42.4233 75.0903 42.4233C74.7854 42.4233 74.5383 42.6705 74.5383 42.9753C74.5383 43.2801 74.7854 43.5272 75.0903 43.5272Z"
        fill="#3C3C3B"
      />
      <path
        d="M76.1953 42.9753C76.1953 43.2801 76.4415 43.5276 76.7466 43.5276C77.0511 43.5276 77.2983 43.2804 77.2983 42.9753C77.2983 42.7956 77.2108 42.6375 77.0777 42.5365C77.0555 42.5228 77.034 42.5079 77.0115 42.494C76.9326 42.4503 76.8433 42.4233 76.7466 42.4233C76.4415 42.4233 76.1953 42.6708 76.1953 42.9753Z"
        fill="#3C3C3B"
      />
      <path
        d="M78.4023 43.5276C78.4473 43.5276 78.4901 43.5209 78.5319 43.5105C78.3082 43.3501 78.0855 43.1892 77.8567 43.0361C77.8874 43.3121 78.1184 43.5276 78.4023 43.5276Z"
        fill="#3C3C3B"
      />
      <path
        d="M47.4952 44.6311C47.4952 44.5158 47.4594 44.4087 47.3989 44.3203C47.1128 44.5488 46.8324 44.7839 46.5564 45.0243C46.6559 45.1226 46.7924 45.1831 46.9433 45.1831C47.2477 45.1828 47.4952 44.936 47.4952 44.6311Z"
        fill="#3C3C3B"
      />
      <path
        d="M48.5988 45.183C48.9036 45.183 49.1508 44.9359 49.1508 44.6311C49.1508 44.3262 48.9036 44.0791 48.5988 44.0791C48.294 44.0791 48.0469 44.3262 48.0469 44.6311C48.0469 44.9359 48.294 45.183 48.5988 45.183Z"
        fill="#3C3C3B"
      />
      <path
        d="M50.2546 44.0791C49.9501 44.0791 49.7026 44.3262 49.7026 44.6311C49.7026 44.7765 49.7603 44.9077 49.8519 45.0062C50.1484 44.7983 50.4498 44.5975 50.7561 44.4029C50.6687 44.2122 50.4776 44.0791 50.2546 44.0791Z"
        fill="#3C3C3B"
      />
      <path
        d="M77.2982 44.6311C77.2982 44.3262 77.0511 44.0791 76.7466 44.0791C76.5232 44.0791 76.3321 44.2122 76.2456 44.4029C76.5517 44.5975 76.853 44.7983 77.1493 45.0062C77.2408 44.9073 77.2982 44.7765 77.2982 44.6311Z"
        fill="#3C3C3B"
      />
      <path
        d="M78.4023 45.183C78.7071 45.183 78.9543 44.9359 78.9543 44.6311C78.9543 44.3262 78.7071 44.0791 78.4023 44.0791C78.0974 44.0791 77.8503 44.3262 77.8503 44.6311C77.8503 44.9359 78.0974 45.183 78.4023 45.183Z"
        fill="#3C3C3B"
      />
      <path
        d="M80.0575 45.1828C80.2086 45.1828 80.3448 45.1223 80.445 45.0241C80.169 44.7836 79.8883 44.5488 79.6022 44.3201C79.542 44.4085 79.5059 44.5156 79.5059 44.6309C79.5059 44.936 79.7533 45.1828 80.0575 45.1828Z"
        fill="#3C3C3B"
      />
      <path
        d="M45.2879 46.8389C45.5924 46.8389 45.8392 46.5917 45.8392 46.2869C45.8392 46.1155 45.7597 45.9647 45.6374 45.8633C45.3744 46.1158 45.1162 46.3737 44.864 46.637C44.9654 46.7593 45.1165 46.8389 45.2879 46.8389Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.9433 46.839C47.2481 46.839 47.4952 46.5919 47.4952 46.2871C47.4952 45.9822 47.2481 45.7351 46.9433 45.7351C46.6385 45.7351 46.3914 45.9822 46.3914 46.2871C46.3914 46.5919 46.6385 46.839 46.9433 46.839Z"
        fill="#3C3C3B"
      />
      <path
        d="M48.5988 45.7351C48.2943 45.7351 48.0469 45.9822 48.0469 46.2874C48.0469 46.3248 48.0507 46.3612 48.058 46.3967C48.3055 46.1853 48.5574 45.9797 48.8137 45.7785C48.7478 45.7503 48.6749 45.7351 48.5988 45.7351Z"
        fill="#3C3C3B"
      />
      <path
        d="M78.9546 46.2871C78.9546 45.9823 78.7071 45.7349 78.4026 45.7349C78.3266 45.7349 78.254 45.7504 78.1877 45.7783C78.4441 45.9795 78.696 46.1851 78.9434 46.3964C78.9507 46.3613 78.9546 46.3245 78.9546 46.2871Z"
        fill="#3C3C3B"
      />
      <path
        d="M80.0575 46.8391C80.3629 46.8391 80.61 46.592 80.61 46.2871C80.61 45.9823 80.3629 45.7349 80.0575 45.7349C79.7533 45.7349 79.5059 45.982 79.5059 46.2871C79.5059 46.592 79.7533 46.8391 80.0575 46.8391Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.1621 46.2871C81.1621 46.5916 81.4086 46.839 81.7131 46.839C81.8845 46.839 82.0356 46.7595 82.137 46.6372C81.8845 46.3739 81.6269 46.116 81.3636 45.8638C81.2416 45.9648 81.1621 46.116 81.1621 46.2871Z"
        fill="#3C3C3B"
      />
      <path
        d="M44.1834 47.9425C44.1834 47.7917 44.1229 47.6552 44.025 47.5557C43.7842 47.8316 43.5493 48.112 43.3206 48.3985C43.409 48.459 43.516 48.4948 43.6314 48.4948C43.9371 48.4948 44.1834 48.2473 44.1834 47.9425Z"
        fill="#3C3C3B"
      />
      <path
        d="M45.2881 48.4948C45.5926 48.4948 45.8395 48.2476 45.8395 47.9428C45.8395 47.638 45.5926 47.3909 45.2881 47.3909C44.9827 47.3909 44.7356 47.638 44.7356 47.9428C44.7356 48.2476 44.9827 48.4948 45.2881 48.4948Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.9621 47.3928C46.9554 47.3928 46.9497 47.3909 46.9434 47.3909C46.6389 47.3909 46.3911 47.638 46.3911 47.9428C46.3911 47.9495 46.3927 47.9552 46.393 47.9618C46.5796 47.7686 46.7688 47.5791 46.9621 47.3928Z"
        fill="#3C3C3B"
      />
      <path
        d="M80.6082 47.9616C80.6085 47.9549 80.61 47.9492 80.61 47.9426C80.61 47.6378 80.3629 47.3906 80.0575 47.3906C80.0511 47.3906 80.0454 47.3922 80.0391 47.3925C80.2323 47.5791 80.4215 47.7686 80.6082 47.9616Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.7134 48.4948C82.0182 48.4948 82.2653 48.2477 82.2653 47.9428C82.2653 47.638 82.0182 47.3909 81.7134 47.3909C81.4086 47.3909 81.1614 47.638 81.1614 47.9428C81.1614 48.2477 81.4086 48.4948 81.7134 48.4948Z"
        fill="#3C3C3B"
      />
      <path
        d="M83.3696 48.4947C83.4849 48.4947 83.5917 48.4589 83.6801 48.3984C83.4514 48.1123 83.2168 47.8319 82.9764 47.5559C82.8781 47.6554 82.8176 47.792 82.8176 47.9428C82.8179 48.2473 83.0648 48.4947 83.3696 48.4947Z"
        fill="#3C3C3B"
      />
      <path
        d="M42.5281 49.5984C42.5281 49.5534 42.5214 49.5103 42.511 49.4685C42.3506 49.6919 42.1897 49.915 42.0366 50.1437C42.3126 50.1136 42.5281 49.8823 42.5281 49.5984Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.6315 50.1501C43.9361 50.1501 44.1832 49.9032 44.1832 49.5985C44.1832 49.2939 43.9361 49.0469 43.6315 49.0469C43.3268 49.0469 43.0798 49.2939 43.0798 49.5985C43.0798 49.9032 43.3268 50.1501 43.6315 50.1501Z"
        fill="#3C3C3B"
      />
      <path
        d="M45.2881 49.0466C44.9827 49.0466 44.7356 49.2938 44.7356 49.5986C44.7356 49.6746 44.7511 49.7472 44.779 49.8131C44.9802 49.5571 45.1858 49.3049 45.3971 49.0574C45.3617 49.0504 45.3252 49.0466 45.2881 49.0466Z"
        fill="#3C3C3B"
      />
      <path
        d="M82.266 49.5986C82.266 49.2938 82.0189 49.0466 81.7135 49.0466C81.6764 49.0466 81.64 49.0504 81.6045 49.0577C81.8158 49.3052 82.0214 49.5574 82.2226 49.8134C82.2505 49.7475 82.266 49.6749 82.266 49.5986Z"
        fill="#3C3C3B"
      />
      <path
        d="M83.3695 50.1501C83.6742 50.1501 83.9212 49.9032 83.9212 49.5985C83.9212 49.2939 83.6742 49.0469 83.3695 49.0469C83.0648 49.0469 82.8179 49.2939 82.8179 49.5985C82.8179 49.9032 83.0648 50.1501 83.3695 50.1501Z"
        fill="#3C3C3B"
      />
      <path
        d="M84.9646 50.144C84.8115 49.9152 84.6506 49.6924 84.4902 49.4688C84.4801 49.5106 84.4731 49.5537 84.4731 49.5986C84.4735 49.8822 84.6889 50.1132 84.9646 50.144Z"
        fill="#3C3C3B"
      />
      <path
        d="M41.9761 51.8063C42.2809 51.8063 42.528 51.5591 42.528 51.2543C42.528 50.9495 42.2809 50.7024 41.9761 50.7024C41.7967 50.7024 41.6389 50.7892 41.5379 50.922C41.5236 50.9451 41.5081 50.9673 41.4941 50.9901C41.4507 51.069 41.4238 51.158 41.4238 51.2543C41.4238 51.5588 41.6713 51.8063 41.9761 51.8063Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.6315 50.7024C43.3266 50.7024 43.0798 50.9495 43.0798 51.2543C43.0798 51.4774 43.2129 51.6688 43.4033 51.7556C43.5979 51.4495 43.7988 51.1482 44.0066 50.8516C43.9084 50.7597 43.7772 50.7024 43.6315 50.7024Z"
        fill="#3C3C3B"
      />
      <path
        d="M83.9213 51.2543C83.9213 50.9495 83.6737 50.7024 83.3695 50.7024C83.2241 50.7024 83.0927 50.7597 82.9941 50.8519C83.202 51.1482 83.4028 51.4495 83.5974 51.7556C83.7878 51.6685 83.9213 51.4774 83.9213 51.2543Z"
        fill="#3C3C3B"
      />
      <path
        d="M85.0253 50.7024C84.7208 50.7024 84.4734 50.9495 84.4734 51.2543C84.4734 51.5588 84.7208 51.8063 85.0253 51.8063C85.3298 51.8063 85.5773 51.5591 85.5773 51.2543C85.5773 51.1577 85.5504 51.0687 85.5066 50.9894C85.4927 50.9669 85.4775 50.9451 85.4635 50.9226C85.3628 50.7895 85.2047 50.7024 85.0253 50.7024Z"
        fill="#3C3C3B"
      />
      <path
        d="M40.8722 52.9098C40.8722 52.7301 40.7851 52.572 40.6523 52.4709C40.4841 52.7897 40.3202 53.1107 40.1653 53.437C40.2147 53.4516 40.266 53.4617 40.3202 53.4617C40.625 53.4617 40.8722 53.2146 40.8722 52.9098Z"
        fill="#3C3C3B"
      />
      <path
        d="M41.976 53.4616C42.2808 53.4616 42.5279 53.2145 42.5279 52.9096C42.5279 52.6048 42.2808 52.3577 41.976 52.3577C41.6712 52.3577 41.4241 52.6048 41.4241 52.9096C41.4241 53.2145 41.6712 53.4616 41.976 53.4616Z"
        fill="#3C3C3B"
      />
      <path
        d="M85.0253 53.4616C85.3302 53.4616 85.5773 53.2145 85.5773 52.9096C85.5773 52.6048 85.3302 52.3577 85.0253 52.3577C84.7205 52.3577 84.4734 52.6048 84.4734 52.9096C84.4734 53.2145 84.7205 53.4616 85.0253 53.4616Z"
        fill="#3C3C3B"
      />
      <path
        d="M86.1294 52.9097C86.1294 53.2145 86.3762 53.4617 86.6807 53.4617C86.7352 53.4617 86.7865 53.4515 86.836 53.437C86.681 53.1106 86.5172 52.7896 86.3489 52.4712C86.2165 52.5719 86.1294 52.7301 86.1294 52.9097Z"
        fill="#3C3C3B"
      />
      <path
        d="M40.3202 55.1176C40.6251 55.1176 40.8722 54.8705 40.8722 54.5656C40.8722 54.2608 40.6251 54.0137 40.3202 54.0137C40.0154 54.0137 39.7683 54.2608 39.7683 54.5656C39.7683 54.8705 40.0154 55.1176 40.3202 55.1176Z"
        fill="#3C3C3B"
      />
      <path
        d="M41.976 54.0137C41.6712 54.0137 41.4241 54.2608 41.4241 54.5659C41.4241 54.756 41.5204 54.9233 41.6667 55.0228C41.8115 54.6898 41.9627 54.3606 42.1217 54.0359C42.0749 54.0225 42.0267 54.0137 41.976 54.0137Z"
        fill="#3C3C3B"
      />
      <path
        d="M85.5775 54.5657C85.5775 54.2606 85.33 54.0134 85.0256 54.0134C84.9749 54.0134 84.9264 54.0223 84.8801 54.0353C85.0392 54.3598 85.1903 54.6893 85.3351 55.0223C85.4812 54.9234 85.5775 54.7555 85.5775 54.5657Z"
        fill="#3C3C3B"
      />
      <path
        d="M86.6807 55.1176C86.9855 55.1176 87.2326 54.8705 87.2326 54.5656C87.2326 54.2608 86.9855 54.0137 86.6807 54.0137C86.3758 54.0137 86.1287 54.2608 86.1287 54.5656C86.1287 54.8705 86.3758 55.1176 86.6807 55.1176Z"
        fill="#3C3C3B"
      />
      <path
        d="M39.2164 56.2213C39.2164 56.1184 39.1863 56.0233 39.1372 55.9409C39.045 56.2036 38.9534 56.4666 38.8691 56.733C39.0722 56.6519 39.2164 56.4539 39.2164 56.2213Z"
        fill="#3C3C3B"
      />
      <path
        d="M40.3202 56.7736C40.6251 56.7736 40.8722 56.5264 40.8722 56.2216C40.8722 55.9168 40.6251 55.6697 40.3202 55.6697C40.0154 55.6697 39.7683 55.9168 39.7683 56.2216C39.7683 56.5264 40.0154 56.7736 40.3202 56.7736Z"
        fill="#3C3C3B"
      />
      <path
        d="M86.6807 56.7736C86.9855 56.7736 87.2326 56.5264 87.2326 56.2216C87.2326 55.9168 86.9855 55.6697 86.6807 55.6697C86.3758 55.6697 86.1287 55.9168 86.1287 56.2216C86.1287 56.5264 86.3758 56.7736 86.6807 56.7736Z"
        fill="#3C3C3B"
      />
      <path
        d="M88.1316 56.7333C88.0473 56.4668 87.9558 56.2038 87.8636 55.9412C87.8148 56.0235 87.7847 56.1189 87.7847 56.2216C87.785 56.4538 87.9285 56.6515 88.1316 56.7333Z"
        fill="#3C3C3B"
      />
      <path
        d="M39.2166 57.8769C39.2166 57.5829 38.9856 57.3446 38.6953 57.3281C38.5962 57.6719 38.5027 58.0182 38.4175 58.368C38.4916 58.4057 38.5752 58.4289 38.6642 58.4289C38.9694 58.4289 39.2166 58.1817 39.2166 57.8769Z"
        fill="#3C3C3B"
      />
      <path
        d="M40.3202 57.325C40.0154 57.325 39.7686 57.5721 39.7686 57.8769C39.7686 58.1814 40.0154 58.4289 40.3202 58.4289C40.3804 58.4289 40.438 58.4168 40.4925 58.3987C40.5702 58.105 40.6523 57.8129 40.741 57.5236C40.6399 57.4032 40.4897 57.325 40.3202 57.325Z"
        fill="#3C3C3B"
      />
      <path
        d="M86.6808 58.4289C86.9859 58.4289 87.2324 58.1817 87.2324 57.8769C87.2324 57.5721 86.9859 57.325 86.6808 57.325C86.5112 57.325 86.3613 57.4032 86.2603 57.5236C86.349 57.8129 86.431 58.1047 86.5086 58.3984C86.5631 58.4168 86.6202 58.4289 86.6808 58.4289Z"
        fill="#3C3C3B"
      />
      <path
        d="M87.7852 57.8771C87.7852 58.1816 88.0317 58.429 88.3372 58.429C88.4265 58.429 88.5095 58.4059 88.5836 58.3682C88.4984 58.0184 88.4049 57.6724 88.3058 57.3286C88.0152 57.3448 87.7852 57.583 87.7852 57.8771Z"
        fill="#3C3C3B"
      />
      <path
        d="M38.6643 60.0849C38.9694 60.0849 39.2163 59.8377 39.2163 59.5329C39.2163 59.2281 38.9694 58.981 38.6643 58.981C38.4843 58.981 38.3256 59.0687 38.2245 59.2024C38.1915 59.3605 38.1646 59.5205 38.1345 59.6796C38.1995 59.9128 38.4108 60.0849 38.6643 60.0849Z"
        fill="#3C3C3B"
      />
      <path
        d="M40.3202 58.981C40.0154 58.981 39.7686 59.2281 39.7686 59.5329C39.7686 59.7674 39.9156 59.9667 40.1218 60.0465C40.1896 59.6894 40.266 59.3352 40.3497 58.9838C40.3395 58.9832 40.3303 58.981 40.3202 58.981Z"
        fill="#3C3C3B"
      />
      <path
        d="M87.2324 59.5329C87.2324 59.2281 86.9859 58.981 86.6808 58.981C86.671 58.981 86.6614 58.9832 86.6516 58.9838C86.7353 59.3352 86.8116 59.6894 86.8794 60.0465C87.0854 59.9667 87.2324 59.7674 87.2324 59.5329Z"
        fill="#3C3C3B"
      />
      <path
        d="M88.3372 58.981C88.0317 58.981 87.7852 59.2281 87.7852 59.5329C87.7852 59.8374 88.0317 60.0849 88.3372 60.0849C88.591 60.0849 88.8023 59.9122 88.8666 59.6786C88.8362 59.5202 88.8096 59.3605 88.7766 59.2034C88.6759 59.069 88.5175 58.981 88.3372 58.981Z"
        fill="#3C3C3B"
      />
      <path
        d="M38.6642 61.7409C38.9691 61.7409 39.2162 61.4938 39.2162 61.1889C39.2162 60.8841 38.9691 60.637 38.6642 60.637C38.3594 60.637 38.1123 60.8841 38.1123 61.1889C38.1123 61.4938 38.3594 61.7409 38.6642 61.7409Z"
        fill="#3C3C3B"
      />
      <path
        d="M39.7686 61.1888C39.7686 61.3187 39.8154 61.4369 39.8909 61.5313C39.9238 61.2674 39.9565 61.0034 39.998 60.7427C39.8595 60.8428 39.7686 61.0047 39.7686 61.1888Z"
        fill="#3C3C3B"
      />
      <path
        d="M87.2325 61.1888C87.2325 61.0047 87.1419 60.8431 87.0034 60.7427C87.0449 61.0038 87.0776 61.2674 87.1106 61.531C87.1856 61.4366 87.2325 61.3187 87.2325 61.1888Z"
        fill="#3C3C3B"
      />
      <path
        d="M88.3372 61.7409C88.6417 61.7409 88.8881 61.4937 88.8881 61.1889C88.8881 60.8841 88.6417 60.637 88.3372 60.637C88.0317 60.637 87.7852 60.8841 87.7852 61.1889C87.7852 61.4934 88.0317 61.7409 88.3372 61.7409Z"
        fill="#3C3C3B"
      />
      <path
        d="M38.6642 63.3961C38.9691 63.3961 39.2162 63.149 39.2162 62.8442C39.2162 62.5394 38.9691 62.2922 38.6642 62.2922C38.3594 62.2922 38.1123 62.5394 38.1123 62.8442C38.1123 63.149 38.3594 63.3961 38.6642 63.3961Z"
        fill="#3C3C3B"
      />
      <path
        d="M88.3372 63.3961C88.642 63.3961 88.8891 63.149 88.8891 62.8442C88.8891 62.5394 88.642 62.2922 88.3372 62.2922C88.0323 62.2922 87.7852 62.5394 87.7852 62.8442C87.7852 63.149 88.0323 63.3961 88.3372 63.3961Z"
        fill="#3C3C3B"
      />
      <path
        d="M38.6642 65.0521C38.9691 65.0521 39.2162 64.805 39.2162 64.5002C39.2162 64.1954 38.9691 63.9482 38.6642 63.9482C38.3594 63.9482 38.1123 64.1954 38.1123 64.5002C38.1123 64.805 38.3594 65.0521 38.6642 65.0521Z"
        fill="#3C3C3B"
      />
      <path
        d="M88.3372 65.0521C88.642 65.0521 88.8891 64.805 88.8891 64.5002C88.8891 64.1954 88.642 63.9482 88.3372 63.9482C88.0323 63.9482 87.7852 64.1954 87.7852 64.5002C87.7852 64.805 88.0323 65.0521 88.3372 65.0521Z"
        fill="#3C3C3B"
      />
      <path
        d="M38.6642 66.7079C38.9691 66.7079 39.2162 66.4608 39.2162 66.156C39.2162 65.8511 38.9691 65.604 38.6642 65.604C38.3594 65.604 38.1123 65.8511 38.1123 66.156C38.1123 66.4608 38.3594 66.7079 38.6642 66.7079Z"
        fill="#3C3C3B"
      />
      <path
        d="M88.3372 66.7079C88.642 66.7079 88.8891 66.4608 88.8891 66.156C88.8891 65.8511 88.642 65.604 88.3372 65.604C88.0323 65.604 87.7852 65.8511 87.7852 66.156C87.7852 66.4608 88.0323 66.7079 88.3372 66.7079Z"
        fill="#3C3C3B"
      />
      <path
        d="M38.6642 68.3634C38.9691 68.3634 39.2162 68.1163 39.2162 67.8115C39.2162 67.5066 38.9691 67.2595 38.6642 67.2595C38.3594 67.2595 38.1123 67.5066 38.1123 67.8115C38.1123 68.1163 38.3594 68.3634 38.6642 68.3634Z"
        fill="#3C3C3B"
      />
      <path
        d="M39.7686 67.8113C39.7686 67.9954 39.8595 68.1576 39.998 68.2577C39.9568 67.9966 39.9238 67.7327 39.8909 67.4688C39.8154 67.5635 39.7686 67.6814 39.7686 67.8113Z"
        fill="#3C3C3B"
      />
      <path
        d="M87.2325 67.8112C87.2325 67.6813 87.186 67.5634 87.1106 67.469C87.0776 67.7329 87.0446 67.9965 87.0034 68.2576C87.1416 68.1572 87.2325 67.9953 87.2325 67.8112Z"
        fill="#3C3C3B"
      />
      <path
        d="M88.3372 68.3634C88.642 68.3634 88.8891 68.1163 88.8891 67.8115C88.8891 67.5066 88.642 67.2595 88.3372 67.2595C88.0323 67.2595 87.7852 67.5066 87.7852 67.8115C87.7852 68.1163 88.0323 68.3634 88.3372 68.3634Z"
        fill="#3C3C3B"
      />
      <path
        d="M38.6643 70.0194C38.9694 70.0194 39.2163 69.7723 39.2163 69.4675C39.2163 69.163 38.9694 68.9155 38.6643 68.9155C38.4105 68.9155 38.1992 69.0876 38.1345 69.3204C38.1646 69.4795 38.1918 69.6398 38.2248 69.7979C38.3256 69.9317 38.4843 70.0194 38.6643 70.0194Z"
        fill="#3C3C3B"
      />
      <path
        d="M39.7686 69.467C39.7686 69.7718 40.0154 70.0189 40.3202 70.0189C40.3303 70.0189 40.3398 70.0167 40.3497 70.0161C40.266 69.6647 40.19 69.3105 40.1221 68.9534C39.9159 69.0332 39.7686 69.2325 39.7686 69.467Z"
        fill="#3C3C3B"
      />
      <path
        d="M86.6805 70.0194C86.9857 70.0194 87.2322 69.7723 87.2322 69.4675C87.2322 69.233 87.0851 69.0337 86.8789 68.9539C86.8111 69.3109 86.735 69.6649 86.6514 70.0166C86.6615 70.0169 86.6707 70.0194 86.6805 70.0194Z"
        fill="#3C3C3B"
      />
      <path
        d="M88.3372 68.9155C88.0317 68.9155 87.7852 69.1627 87.7852 69.4675C87.7852 69.7723 88.0317 70.0194 88.3372 70.0194C88.5175 70.0194 88.6759 69.9313 88.7766 69.7973C88.8096 69.6398 88.8362 69.4801 88.8663 69.3217C88.8023 69.0882 88.591 68.9155 88.3372 68.9155Z"
        fill="#3C3C3B"
      />
      <path
        d="M39.2167 71.1232C39.2167 70.8184 38.9699 70.5713 38.6648 70.5713C38.5758 70.5713 38.4924 70.5944 38.418 70.6321C38.5032 70.9819 38.5966 71.3279 38.6961 71.672C38.9861 71.6552 39.2167 71.4173 39.2167 71.1232Z"
        fill="#3C3C3B"
      />
      <path
        d="M40.3202 70.571C40.0154 70.571 39.7686 70.8182 39.7686 71.123C39.7686 71.4278 40.0154 71.675 40.3202 71.675C40.49 71.675 40.6399 71.5967 40.741 71.4763C40.6526 71.187 40.5702 70.8952 40.4925 70.6012C40.438 70.5831 40.3807 70.571 40.3202 70.571Z"
        fill="#3C3C3B"
      />
      <path
        d="M86.6808 71.675C86.9859 71.675 87.2324 71.4278 87.2324 71.123C87.2324 70.8182 86.9859 70.571 86.6808 70.571C86.6202 70.571 86.5631 70.5831 86.5086 70.6012C86.431 70.8949 86.3487 71.187 86.2603 71.476C86.3616 71.597 86.5112 71.675 86.6808 71.675Z"
        fill="#3C3C3B"
      />
      <path
        d="M87.7852 71.1232C87.7852 71.4173 88.0155 71.6552 88.3061 71.6717C88.4052 71.3279 88.4987 70.9816 88.5839 70.6321C88.5098 70.5944 88.4265 70.5713 88.3375 70.5713C88.0317 70.571 87.7852 70.8184 87.7852 71.1232Z"
        fill="#3C3C3B"
      />
      <path
        d="M38.8691 72.2671C38.9534 72.5336 39.045 72.7965 39.1375 73.0592C39.1863 72.9768 39.2164 72.8815 39.2164 72.7788C39.2164 72.5465 39.0726 72.3485 38.8691 72.2671Z"
        fill="#3C3C3B"
      />
      <path
        d="M40.3202 73.3307C40.6251 73.3307 40.8722 73.0836 40.8722 72.7788C40.8722 72.4739 40.6251 72.2268 40.3202 72.2268C40.0154 72.2268 39.7683 72.4739 39.7683 72.7788C39.7683 73.0836 40.0154 73.3307 40.3202 73.3307Z"
        fill="#3C3C3B"
      />
      <path
        d="M86.6807 73.3307C86.9855 73.3307 87.2326 73.0836 87.2326 72.7788C87.2326 72.4739 86.9855 72.2268 86.6807 72.2268C86.3758 72.2268 86.1287 72.4739 86.1287 72.7788C86.1287 73.0836 86.3758 73.3307 86.6807 73.3307Z"
        fill="#3C3C3B"
      />
      <path
        d="M87.7852 72.7788C87.7852 72.8818 87.8153 72.9768 87.8641 73.0589C87.9563 72.7965 88.0478 72.5336 88.1321 72.2671C87.9284 72.3488 87.7852 72.5465 87.7852 72.7788Z"
        fill="#3C3C3B"
      />
      <path
        d="M40.3202 74.9865C40.6251 74.9865 40.8722 74.7394 40.8722 74.4345C40.8722 74.1297 40.6251 73.8826 40.3202 73.8826C40.0154 73.8826 39.7683 74.1297 39.7683 74.4345C39.7683 74.7394 40.0154 74.9865 40.3202 74.9865Z"
        fill="#3C3C3B"
      />
      <path
        d="M41.4238 74.4342C41.4238 74.739 41.671 74.9862 41.9758 74.9862C42.0265 74.9862 42.0749 74.9773 42.1212 74.9643C41.9621 74.6395 41.811 74.3103 41.6662 73.9773C41.5201 74.0765 41.4238 74.2441 41.4238 74.4342Z"
        fill="#3C3C3B"
      />
      <path
        d="M85.0254 74.9862C85.3299 74.9862 85.5773 74.739 85.5773 74.4342C85.5773 74.2441 85.481 74.0768 85.3346 73.9773C85.1898 74.31 85.0387 74.6395 84.8796 74.964C84.9262 74.9773 84.9747 74.9862 85.0254 74.9862Z"
        fill="#3C3C3B"
      />
      <path
        d="M86.6807 74.9865C86.9855 74.9865 87.2326 74.7394 87.2326 74.4345C87.2326 74.1297 86.9855 73.8826 86.6807 73.8826C86.3758 73.8826 86.1287 74.1297 86.1287 74.4345C86.1287 74.7394 86.3758 74.9865 86.6807 74.9865Z"
        fill="#3C3C3B"
      />
      <path
        d="M40.8722 76.0903C40.8722 75.7855 40.625 75.5383 40.3202 75.5383C40.266 75.5383 40.2147 75.5485 40.1653 75.563C40.3205 75.8891 40.4841 76.21 40.6523 76.5288C40.7851 76.428 40.8722 76.2699 40.8722 76.0903Z"
        fill="#3C3C3B"
      />
      <path
        d="M41.976 76.6422C42.2808 76.6422 42.5279 76.3951 42.5279 76.0903C42.5279 75.7854 42.2808 75.5383 41.976 75.5383C41.6712 75.5383 41.4241 75.7854 41.4241 76.0903C41.4241 76.3951 41.6712 76.6422 41.976 76.6422Z"
        fill="#3C3C3B"
      />
      <path
        d="M85.0253 76.6422C85.3302 76.6422 85.5773 76.3951 85.5773 76.0903C85.5773 75.7854 85.3302 75.5383 85.0253 75.5383C84.7205 75.5383 84.4734 75.7854 84.4734 76.0903C84.4734 76.3951 84.7205 76.6422 85.0253 76.6422Z"
        fill="#3C3C3B"
      />
      <path
        d="M86.1294 76.0903C86.1294 76.2699 86.2165 76.4277 86.3489 76.5288C86.5172 76.2104 86.6807 75.8891 86.8357 75.563C86.7862 75.5485 86.7352 75.5383 86.6807 75.5383C86.3762 75.5383 86.1294 75.7855 86.1294 76.0903Z"
        fill="#3C3C3B"
      />
      <path
        d="M41.976 78.2981C42.2808 78.2981 42.5279 78.0509 42.5279 77.7458C42.5279 77.4413 42.2808 77.1938 41.976 77.1938C41.6712 77.1938 41.4241 77.441 41.4241 77.7458C41.4241 77.8415 41.4507 77.9302 41.4935 78.0085C41.5084 78.0326 41.5241 78.0554 41.5387 78.0795C41.6392 78.2116 41.797 78.2981 41.976 78.2981Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.0798 77.7457C43.0798 78.0505 43.3266 78.298 43.6315 78.298C43.7772 78.298 43.9084 78.2406 44.0069 78.1484C43.7991 77.8519 43.5982 77.5505 43.4036 77.2441C43.2129 77.3313 43.0798 77.5227 43.0798 77.7457Z"
        fill="#3C3C3B"
      />
      <path
        d="M83.3695 78.2979C83.6737 78.2979 83.9212 78.0508 83.9212 77.7456C83.9212 77.5226 83.7878 77.3315 83.5977 77.2444C83.4031 77.5505 83.2022 77.8518 82.9944 78.1483C83.0926 78.2402 83.2237 78.2979 83.3695 78.2979Z"
        fill="#3C3C3B"
      />
      <path
        d="M85.0253 77.1941C84.7208 77.1941 84.4734 77.4412 84.4734 77.746C84.4734 78.0509 84.7208 78.2983 85.0253 78.2983C85.204 78.2983 85.3622 78.2115 85.4629 78.079C85.4778 78.0556 85.4933 78.0328 85.5079 78.0093C85.551 77.9308 85.5776 77.8421 85.5776 77.746C85.5772 77.4412 85.3298 77.1941 85.0253 77.1941Z"
        fill="#3C3C3B"
      />
      <path
        d="M42.0366 78.8562C42.19 79.085 42.3506 79.3077 42.5113 79.5311C42.5211 79.4893 42.5281 79.4462 42.5281 79.4015C42.5281 79.1176 42.3126 78.8866 42.0366 78.8562Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.6315 79.9536C43.9361 79.9536 44.1832 79.7066 44.1832 79.402C44.1832 79.0973 43.9361 78.8503 43.6315 78.8503C43.3268 78.8503 43.0798 79.0973 43.0798 79.402C43.0798 79.7066 43.3268 79.9536 43.6315 79.9536Z"
        fill="#3C3C3B"
      />
      <path
        d="M44.7356 79.4016C44.7356 79.7064 44.9827 79.9535 45.2881 79.9535C45.3255 79.9535 45.3617 79.9497 45.3971 79.9425C45.1861 79.695 44.9802 79.4428 44.779 79.1868C44.7508 79.253 44.7356 79.3252 44.7356 79.4016Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.7135 79.9535C82.0189 79.9535 82.266 79.7064 82.266 79.4016C82.266 79.3252 82.2505 79.253 82.2226 79.1868C82.0214 79.4428 81.8155 79.695 81.6045 79.9425C81.6397 79.9497 81.6758 79.9535 81.7135 79.9535Z"
        fill="#3C3C3B"
      />
      <path
        d="M83.3695 79.9536C83.6742 79.9536 83.9212 79.7066 83.9212 79.402C83.9212 79.0973 83.6742 78.8503 83.3695 78.8503C83.0648 78.8503 82.8179 79.0973 82.8179 79.402C82.8179 79.7066 83.0648 79.9536 83.3695 79.9536Z"
        fill="#3C3C3B"
      />
      <path
        d="M84.4734 79.4015C84.4734 79.4465 84.48 79.4893 84.4905 79.5311C84.6508 79.3074 84.8115 79.0846 84.9648 78.8562C84.6889 78.8866 84.4734 79.1176 84.4734 79.4015Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.6316 80.5054C43.5163 80.5054 43.4095 80.5409 43.3208 80.6017C43.5499 80.8878 43.7847 81.1682 44.0252 81.4442C44.1231 81.3447 44.1836 81.2081 44.1836 81.0573C44.1833 80.7525 43.9371 80.5054 43.6316 80.5054Z"
        fill="#3C3C3B"
      />
      <path
        d="M45.288 81.6093C45.5929 81.6093 45.84 81.3622 45.84 81.0573C45.84 80.7525 45.5929 80.5054 45.288 80.5054C44.9832 80.5054 44.7361 80.7525 44.7361 81.0573C44.7361 81.3622 44.9832 81.6093 45.288 81.6093Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.393 81.0383C46.3927 81.0447 46.3911 81.0507 46.3911 81.0573C46.3911 81.3621 46.6389 81.6093 46.9434 81.6093C46.9497 81.6093 46.9557 81.6077 46.9621 81.6074C46.7688 81.4211 46.5796 81.2313 46.393 81.0383Z"
        fill="#3C3C3B"
      />
      <path
        d="M80.0391 81.6074C80.0454 81.6074 80.0511 81.6093 80.0575 81.6093C80.3629 81.6093 80.61 81.3625 80.61 81.0573C80.61 81.0507 80.6085 81.0447 80.6082 81.0383C80.4215 81.2313 80.2323 81.4211 80.0391 81.6074Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.7136 80.5054C81.4091 80.5054 81.1626 80.7525 81.1626 81.0573C81.1626 81.3621 81.4091 81.6093 81.7136 81.6093C82.019 81.6093 82.2662 81.3625 82.2662 81.0573C82.2662 80.7525 82.0187 80.5054 81.7136 80.5054Z"
        fill="#3C3C3B"
      />
      <path
        d="M82.8179 81.0573C82.8179 81.2081 82.8784 81.3444 82.9763 81.4442C83.2168 81.1682 83.4516 80.8878 83.6804 80.6017C83.592 80.5412 83.4852 80.5054 83.3699 80.5054C83.0648 80.5054 82.8179 80.7525 82.8179 81.0573Z"
        fill="#3C3C3B"
      />
      <path
        d="M45.8392 82.7131C45.8392 82.4086 45.5924 82.1611 45.2879 82.1611C45.1165 82.1611 44.9654 82.2407 44.864 82.363C45.1165 82.6263 45.3744 82.8842 45.6377 83.1364C45.76 83.0353 45.8392 82.8845 45.8392 82.7131Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.9433 83.2653C47.2481 83.2653 47.4952 83.0182 47.4952 82.7133C47.4952 82.4085 47.2481 82.1614 46.9433 82.1614C46.6385 82.1614 46.3914 82.4085 46.3914 82.7133C46.3914 83.0182 46.6385 83.2653 46.9433 83.2653Z"
        fill="#3C3C3B"
      />
      <path
        d="M48.0469 82.7129C48.0469 83.018 48.2943 83.2652 48.5988 83.2652C48.6749 83.2652 48.7478 83.2497 48.8137 83.2218C48.5577 83.0206 48.3055 82.8146 48.058 82.6033C48.0504 82.6388 48.0469 82.6755 48.0469 82.7129Z"
        fill="#3C3C3B"
      />
      <path
        d="M78.4023 83.2652C78.7068 83.2652 78.9543 83.018 78.9543 82.7129C78.9543 82.6752 78.9505 82.6388 78.9432 82.6033C78.6957 82.8146 78.4438 83.0203 78.1875 83.2218C78.2537 83.2497 78.3263 83.2652 78.4023 83.2652Z"
        fill="#3C3C3B"
      />
      <path
        d="M80.0575 83.2653C80.3624 83.2653 80.6095 83.0182 80.6095 82.7133C80.6095 82.4085 80.3624 82.1614 80.0575 82.1614C79.7527 82.1614 79.5056 82.4085 79.5056 82.7133C79.5056 83.0182 79.7527 83.2653 80.0575 83.2653Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.7136 82.1611C81.4091 82.1611 81.1626 82.4083 81.1626 82.7131C81.1626 82.8845 81.2418 83.0353 81.3641 83.1364C81.6271 82.8839 81.8853 82.6263 82.1375 82.363C82.0358 82.2407 81.885 82.1611 81.7136 82.1611Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.9433 83.8169C46.7924 83.8169 46.6562 83.8777 46.5564 83.976C46.8324 84.2161 47.1128 84.4512 47.3989 84.68C47.4591 84.5913 47.4952 84.4845 47.4952 84.3692C47.4952 84.064 47.2477 83.8169 46.9433 83.8169Z"
        fill="#3C3C3B"
      />
      <path
        d="M48.5988 84.9208C48.9036 84.9208 49.1508 84.6737 49.1508 84.3688C49.1508 84.064 48.9036 83.8169 48.5988 83.8169C48.294 83.8169 48.0469 84.064 48.0469 84.3688C48.0469 84.6737 48.294 84.9208 48.5988 84.9208Z"
        fill="#3C3C3B"
      />
      <path
        d="M49.7026 84.3688C49.7026 84.6736 49.9501 84.9208 50.2546 84.9208C50.4773 84.9208 50.6687 84.7877 50.7558 84.597C50.4494 84.4024 50.1481 84.2015 49.8519 83.9937C49.7603 84.0922 49.7026 84.2234 49.7026 84.3688Z"
        fill="#3C3C3B"
      />
      <path
        d="M76.7466 84.9208C77.0511 84.9208 77.2983 84.6736 77.2983 84.3688C77.2983 84.2234 77.2409 84.0922 77.149 83.9937C76.8528 84.2015 76.5514 84.4024 76.2454 84.597C76.3322 84.7877 76.5232 84.9208 76.7466 84.9208Z"
        fill="#3C3C3B"
      />
      <path
        d="M78.4023 84.9208C78.7071 84.9208 78.9543 84.6737 78.9543 84.3688C78.9543 84.064 78.7071 83.8169 78.4023 83.8169C78.0974 83.8169 77.8503 84.064 77.8503 84.3688C77.8503 84.6737 78.0974 84.9208 78.4023 84.9208Z"
        fill="#3C3C3B"
      />
      <path
        d="M79.5059 84.3688C79.5059 84.4842 79.5416 84.5913 79.6022 84.6797C79.8883 84.4509 80.169 84.2161 80.445 83.9756C80.3455 83.8774 80.2089 83.8169 80.0575 83.8169C79.7533 83.8169 79.5059 84.064 79.5059 84.3688Z"
        fill="#3C3C3B"
      />
      <path
        d="M48.5987 85.4727C48.5541 85.4727 48.5113 85.4793 48.4695 85.4894C48.6929 85.6501 48.916 85.8107 49.1447 85.9641C49.1143 85.6881 48.8833 85.4727 48.5987 85.4727Z"
        fill="#3C3C3B"
      />
      <path
        d="M50.8067 86.0246C50.8067 85.7195 50.5596 85.4727 50.2551 85.4727C49.9506 85.4727 49.7031 85.7195 49.7031 86.0246C49.7031 86.2043 49.7906 86.3624 49.924 86.4634C49.9455 86.4771 49.9668 86.4913 49.9886 86.505C50.0682 86.549 50.1578 86.5766 50.2551 86.5766C50.5592 86.5766 50.8067 86.3291 50.8067 86.0246Z"
        fill="#3C3C3B"
      />
      <path
        d="M51.9108 86.5766C52.2157 86.5766 52.4628 86.3294 52.4628 86.0246C52.4628 85.7198 52.2157 85.4727 51.9108 85.4727C51.606 85.4727 51.3589 85.7198 51.3589 86.0246C51.3589 86.3294 51.606 86.5766 51.9108 86.5766Z"
        fill="#3C3C3B"
      />
      <path
        d="M53.0144 86.0247C53.0144 86.3292 53.2609 86.5763 53.5657 86.5763C53.7561 86.5763 53.9238 86.48 54.0227 86.3339C53.69 86.1894 53.3604 86.0383 53.036 85.8789C53.0236 85.9258 53.0144 85.974 53.0144 86.0247Z"
        fill="#3C3C3B"
      />
      <path
        d="M73.4352 86.5767C73.7394 86.5767 73.9871 86.3296 73.9871 86.0251C73.9871 85.9744 73.9782 85.9259 73.9653 85.8796C73.6405 86.0387 73.3113 86.1898 72.9783 86.3346C73.0774 86.4804 73.2448 86.5767 73.4352 86.5767Z"
        fill="#3C3C3B"
      />
      <path
        d="M75.0903 85.4727C74.7858 85.4727 74.5393 85.7195 74.5393 86.0246C74.5393 86.3291 74.7858 86.5762 75.0903 86.5762C75.3958 86.5762 75.6429 86.3291 75.6429 86.0246C75.6429 85.7195 75.3958 85.4727 75.0903 85.4727Z"
        fill="#3C3C3B"
      />
      <path
        d="M77.2983 86.0246C77.2983 85.7195 77.0511 85.4727 76.7466 85.4727C76.4415 85.4727 76.1953 85.7195 76.1953 86.0246C76.1953 86.3291 76.4415 86.5762 76.7466 86.5762C76.8439 86.5762 76.9342 86.5487 77.0134 86.5046C77.035 86.491 77.0559 86.4767 77.0771 86.4638C77.2108 86.3633 77.2983 86.2049 77.2983 86.0246Z"
        fill="#3C3C3B"
      />
      <path
        d="M77.8569 85.9641C78.0857 85.8107 78.3085 85.6498 78.5319 85.4894C78.49 85.4796 78.447 85.4727 78.4026 85.4727C78.1181 85.4727 77.8874 85.6881 77.8569 85.9641Z"
        fill="#3C3C3B"
      />
      <path
        d="M51.9108 87.1287C51.7309 87.1287 51.5728 87.2155 51.4717 87.3485C51.7904 87.5168 52.1117 87.6803 52.4381 87.8355C52.4527 87.7861 52.4628 87.7348 52.4628 87.6803C52.4628 87.3758 52.2153 87.1287 51.9108 87.1287Z"
        fill="#3C3C3B"
      />
      <path
        d="M53.566 87.1287C53.2612 87.1287 53.0146 87.3758 53.0146 87.6803C53.0146 87.9854 53.2612 88.2322 53.566 88.2322C53.8714 88.2322 54.1183 87.9854 54.1183 87.6803C54.1183 87.3758 53.8714 87.1287 53.566 87.1287Z"
        fill="#3C3C3B"
      />
      <path
        d="M55.2216 88.2321C55.5264 88.2321 55.7735 87.985 55.7735 87.6801C55.7735 87.3753 55.5264 87.1282 55.2216 87.1282C54.9168 87.1282 54.6697 87.3753 54.6697 87.6801C54.6697 87.985 54.9168 88.2321 55.2216 88.2321Z"
        fill="#3C3C3B"
      />
      <path
        d="M56.3259 87.6801C56.3259 87.9853 56.5734 88.2321 56.8779 88.2321C57.1824 88.2321 57.4298 87.9853 57.4298 87.6801C57.4298 87.6199 57.4178 87.5626 57.3994 87.5081C57.1057 87.4308 56.8136 87.3484 56.5243 87.26C56.4042 87.3608 56.3259 87.5106 56.3259 87.6801Z"
        fill="#3C3C3B"
      />
      <path
        d="M57.9814 87.6801C57.9814 87.9852 58.2283 88.2321 58.5328 88.2321C58.7675 88.2321 58.9672 88.0854 59.047 87.8788C58.6899 87.8113 58.3357 87.7349 57.9843 87.6516C57.984 87.6608 57.9814 87.6703 57.9814 87.6801Z"
        fill="#3C3C3B"
      />
      <path
        d="M60.1888 88.2322C60.319 88.2322 60.4372 88.1857 60.5316 88.1103C60.2677 88.0773 60.0038 88.0447 59.7427 88.0032C59.8428 88.1413 60.0047 88.2322 60.1888 88.2322Z"
        fill="#3C3C3B"
      />
      <path
        d="M66.8125 88.2322C66.9966 88.2322 67.1582 88.1413 67.2583 88.0032C66.9972 88.0447 66.7336 88.0773 66.47 88.1103C66.5641 88.1857 66.6823 88.2322 66.8125 88.2322Z"
        fill="#3C3C3B"
      />
      <path
        d="M68.4683 88.2322C68.7728 88.2322 69.0202 87.9854 69.0202 87.6803C69.0202 87.6704 69.0177 87.6609 69.0171 87.6511C68.6657 87.7348 68.3114 87.8111 67.9543 87.8789C68.0342 88.0855 68.2335 88.2322 68.4683 88.2322Z"
        fill="#3C3C3B"
      />
      <path
        d="M69.5715 87.6801C69.5715 87.9853 69.819 88.2321 70.1235 88.2321C70.4286 88.2321 70.6754 87.9853 70.6754 87.6801C70.6754 87.5106 70.5975 87.3608 70.4771 87.26C70.1878 87.3484 69.8957 87.4308 69.6016 87.5081C69.5836 87.5626 69.5715 87.6196 69.5715 87.6801Z"
        fill="#3C3C3B"
      />
      <path
        d="M71.7795 88.2321C72.0843 88.2321 72.3314 87.985 72.3314 87.6801C72.3314 87.3753 72.0843 87.1282 71.7795 87.1282C71.4746 87.1282 71.2275 87.3753 71.2275 87.6801C71.2275 87.985 71.4746 88.2321 71.7795 88.2321Z"
        fill="#3C3C3B"
      />
      <path
        d="M73.4354 87.1287C73.1303 87.1287 72.8831 87.3758 72.8831 87.6803C72.8831 87.9854 73.1303 88.2322 73.4354 88.2322C73.7396 88.2322 73.9873 87.9854 73.9873 87.6803C73.9873 87.3758 73.7396 87.1287 73.4354 87.1287Z"
        fill="#3C3C3B"
      />
      <path
        d="M75.0903 87.1287C74.7858 87.1287 74.5393 87.3758 74.5393 87.6803C74.5393 87.7348 74.5494 87.7858 74.5637 87.8349C74.8897 87.6803 75.211 87.5165 75.5295 87.3485C75.4287 87.2155 75.2706 87.1287 75.0903 87.1287Z"
        fill="#3C3C3B"
      />
      <path
        d="M55.2215 88.7842C55.1189 88.7842 55.0238 88.8143 54.9414 88.8631C55.2041 88.9556 55.4664 89.0472 55.7332 89.1308C55.6518 88.928 55.4538 88.7842 55.2215 88.7842Z"
        fill="#3C3C3B"
      />
      <path
        d="M56.8779 88.7842C56.5838 88.7842 56.3456 89.0152 56.3291 89.3051C56.6732 89.4042 57.0195 89.4977 57.369 89.5833C57.4067 89.5088 57.4298 89.4255 57.4298 89.3364C57.4298 89.0316 57.1824 88.7842 56.8779 88.7842Z"
        fill="#3C3C3B"
      />
      <path
        d="M59.0859 89.3361C59.0859 89.0313 58.8384 88.7842 58.5332 88.7842C58.2288 88.7842 57.9819 89.0313 57.9819 89.3361C57.9819 89.5161 58.0697 89.6749 58.2031 89.7756C58.3612 89.8086 58.5209 89.8355 58.68 89.8659C58.9135 89.801 59.0859 89.5899 59.0859 89.3361Z"
        fill="#3C3C3B"
      />
      <path
        d="M60.1889 89.8881C60.4937 89.8881 60.7408 89.641 60.7408 89.3361C60.7408 89.0313 60.4937 88.7842 60.1889 88.7842C59.8841 88.7842 59.637 89.0313 59.637 89.3361C59.637 89.641 59.8841 89.8881 60.1889 89.8881Z"
        fill="#3C3C3B"
      />
      <path
        d="M61.8454 89.8881C62.1502 89.8881 62.3973 89.641 62.3973 89.3361C62.3973 89.0313 62.1502 88.7842 61.8454 88.7842C61.5406 88.7842 61.2935 89.0313 61.2935 89.3361C61.2935 89.641 61.5406 89.8881 61.8454 89.8881Z"
        fill="#3C3C3B"
      />
      <path
        d="M63.5007 89.8881C63.8055 89.8881 64.0527 89.641 64.0527 89.3361C64.0527 89.0313 63.8055 88.7842 63.5007 88.7842C63.1958 88.7842 62.9487 89.0313 62.9487 89.3361C62.9487 89.641 63.1958 89.8881 63.5007 89.8881Z"
        fill="#3C3C3B"
      />
      <path
        d="M65.1559 89.8881C65.4608 89.8881 65.7079 89.641 65.7079 89.3361C65.7079 89.0313 65.4608 88.7842 65.1559 88.7842C64.8511 88.7842 64.604 89.0313 64.604 89.3361C64.604 89.641 64.8511 89.8881 65.1559 89.8881Z"
        fill="#3C3C3B"
      />
      <path
        d="M66.8122 89.8881C67.117 89.8881 67.3641 89.641 67.3641 89.3361C67.3641 89.0313 67.117 88.7842 66.8122 88.7842C66.5074 88.7842 66.2603 89.0313 66.2603 89.3361C66.2603 89.641 66.5074 89.8881 66.8122 89.8881Z"
        fill="#3C3C3B"
      />
      <path
        d="M69.02 89.3361C69.02 89.0313 68.7726 88.7842 68.4681 88.7842C68.163 88.7842 67.9158 89.0313 67.9158 89.3361C67.9158 89.5899 68.0881 89.801 68.3213 89.8659C68.4804 89.8355 68.6404 89.8082 68.7986 89.7756C68.9323 89.6749 69.02 89.5164 69.02 89.3361Z"
        fill="#3C3C3B"
      />
      <path
        d="M70.1235 88.7842C69.819 88.7842 69.5715 89.0313 69.5715 89.3361C69.5715 89.4252 69.5946 89.5085 69.6323 89.583C69.9821 89.4974 70.3281 89.4043 70.6722 89.3048C70.6558 89.0152 70.4181 88.7842 70.1235 88.7842Z"
        fill="#3C3C3B"
      />
      <path
        d="M71.2678 89.1308C71.5343 89.0472 71.797 88.9556 72.0593 88.8634C71.9769 88.8146 71.8822 88.7842 71.7795 88.7842C71.5473 88.7842 71.3496 88.928 71.2678 89.1308Z"
        fill="#3C3C3B"
      />
      <path
        d="M99.192 91.7476C99.4051 91.4259 99.3404 91.2022 98.9878 91.0459C98.8461 90.9834 98.731 90.9846 98.5904 91.0503C98.5257 91.0807 98.474 91.1206 98.4279 91.1757C98.1883 91.4603 98.0646 91.7808 97.9437 92.1204C97.6417 92.9672 97.6143 93.7251 97.8527 94.5922C98.0787 95.4114 98.6775 96.0322 98.8563 96.8807C99.0497 97.7989 98.9147 98.504 98.3952 99.2844C98.2468 99.5065 98.2591 99.6662 98.4357 99.8653C98.9749 100.475 99.468 99.4042 99.6424 98.9117C99.9443 98.0643 99.9719 97.3069 99.7335 96.4399C99.5075 95.6195 98.9085 94.9993 98.7297 94.1502C98.5363 93.2326 98.6735 92.5286 99.192 91.7476Z"
        fill="#575756"
      />
      <path
        d="M96.3455 91.7476C96.5586 91.4259 96.4939 91.2022 96.1414 91.0459C95.9997 90.9834 95.8845 90.9846 95.744 91.0503C95.6793 91.0807 95.6275 91.1206 95.5814 91.1757C95.3419 91.4603 95.2181 91.7808 95.0973 92.1204C94.7953 92.9672 94.7678 93.7251 95.0062 94.5922C95.2323 95.4114 95.8311 96.0322 96.0099 96.8807C96.2033 97.7989 96.0683 98.504 95.5488 99.2844C95.4003 99.5065 95.4127 99.6662 95.5893 99.8653C96.1285 100.475 96.6216 99.4042 96.7959 98.9117C97.0979 98.0643 97.1255 97.3069 96.8871 96.4399C96.661 95.6195 96.0621 94.9993 95.8833 94.1502C95.6899 93.2326 95.8271 92.5286 96.3455 91.7476Z"
        fill="#575756"
      />
      <path
        d="M93.4988 91.7476C93.7119 91.4259 93.6473 91.2022 93.2947 91.0459C93.153 90.9834 93.0379 90.9846 92.8973 91.0503C92.8326 91.0807 92.7809 91.1206 92.7348 91.1757C92.4952 91.4603 92.3715 91.7808 92.2506 92.1204C91.9486 92.9672 91.9212 93.7251 92.1596 94.5922C92.3856 95.4114 92.9844 96.0322 93.1632 96.8807C93.3566 97.7989 93.2216 98.504 92.7021 99.2844C92.5536 99.5065 92.566 99.6662 92.7426 99.8653C93.2818 100.475 93.7749 99.4042 93.9492 98.9117C94.2512 98.0643 94.2788 97.3069 94.0404 96.4399C93.8144 95.6195 93.2154 94.9993 93.0366 94.1502C92.8432 93.2326 92.9804 92.5286 93.4988 91.7476Z"
        fill="#575756"
      />
      <path
        d="M332.144 20.2554V19.9998H244.656"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M332.144 19.9998C332.324 19.9998 332.399 20.0748 332.399 20.2554C332.399 49.419 332.399 78.5809 332.399 107.744C332.399 107.924 332.324 108 332.144 108C302.981 108 273.818 108 244.656 108C244.475 108 244.4 107.924 244.4 107.744C244.4 78.5814 244.4 49.419 244.4 20.2554C244.4 20.0748 244.475 19.9998 244.656 19.9998"
        fill="#E3E3E3"
      />
      <path
        d="M244 108.48C244 79.0936 244 49.7068 244 20.3201C243.998 20.0932 244.093 19.9983 244.319 20C273.706 20 303.093 20 332.48 20C332.707 19.9989 332.801 20.0926 332.799 20.3201C332.799 49.7068 332.799 79.0936 332.799 108.48C332.801 108.708 332.707 108.802 332.48 108.8C303.093 108.8 273.706 108.8 244.319 108.8C244.093 108.802 243.998 108.708 244 108.48Z"
        fill="#575756"
      />
      <path
        d="M332.4 108.08C332.4 78.9597 332.4 49.84 332.4 20.7202C332.4 20.4939 332.306 20.4001 332.08 20.4001C302.96 20.4001 273.84 20.4001 244.72 20.4001C244.494 20.4001 244.4 20.4939 244.4 20.7202C244.4 49.84 244.4 78.9603 244.4 108.08C244.4 108.306 244.494 108.4 244.72 108.4C273.84 108.4 302.96 108.4 332.08 108.4C332.306 108.4 332.4 108.306 332.4 108.08Z"
        fill="#E3E3E3"
      />
      <path
        d="M320.876 98.1137C321.108 97.564 321.422 97.3557 322.018 97.3551C323.006 97.3562 323.597 98.4558 323.049 99.2787C322.502 100.102 321.26 99.9843 320.876 99.0738C319.421 99.0738 317.967 99.0738 316.512 99.0738C315.37 99.0727 314.438 98.1448 314.439 97.0007C314.44 95.856 315.368 94.9286 316.512 94.9269C317.252 94.9269 317.991 94.9269 318.731 94.9269C319.345 94.9263 319.846 94.4279 319.844 93.8132C319.844 93.1991 319.346 92.7007 318.731 92.7001C317.277 92.7001 315.822 92.7001 314.368 92.7001C313.842 93.9442 311.985 93.5711 311.987 92.2198C311.989 90.8679 313.843 90.4943 314.368 91.7394C315.822 91.7394 317.277 91.7394 318.731 91.7394C319.874 91.7406 320.806 92.6685 320.805 93.8127C320.804 94.9574 319.876 95.8847 318.731 95.8864C317.991 95.8864 317.252 95.8864 316.512 95.8864C315.898 95.887 315.398 96.3854 315.399 97.0001C315.4 97.6142 315.897 98.1121 316.512 98.1132C317.967 98.1137 319.422 98.1137 320.876 98.1137Z"
        fill="#575756"
      />
      <path
        d="M288.398 71.202C292.155 71.202 295.2 68.1569 295.2 64.4004C295.2 60.644 292.155 57.5989 288.398 57.5989C284.642 57.5989 281.597 60.644 281.597 64.4004C281.597 68.1569 284.642 71.202 288.398 71.202Z"
        fill="#575756"
      />
      <path
        d="M288.399 70.8018C291.934 70.8018 294.8 67.9358 294.8 64.4004C294.8 60.865 291.934 57.999 288.399 57.999C284.863 57.999 281.997 60.865 281.997 64.4004C281.997 67.9358 284.863 70.8018 288.399 70.8018Z"
        fill="#E3E3E3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6152_24427"
          x1="176"
          y1="109.076"
          x2="176"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6152_24427"
          x1="16.5595"
          y1="63.9993"
          x2="0.308842"
          y2="63.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6152_24427"
          x1="335.441"
          y1="63.9996"
          x2="351.691"
          y2="63.9996"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6152_24427"
          x1="45.2411"
          y1="46.2411"
          x2="81.759"
          y2="82.759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDBCBC" />
          <stop offset="0.0744" stopColor="#BABAB9" />
          <stop offset="0.1382" stopColor="#B1B1B1" />
          <stop offset="0.1981" stopColor="#A3A2A2" />
          <stop offset="0.2553" stopColor="#8E8E8D" />
          <stop offset="0.2921" stopColor="#7C7C7B" />
          <stop offset="0.505" stopColor="white" />
          <stop offset="0.5099" stopColor="#F1F1F1" />
          <stop offset="0.703" stopColor="#878787" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <radialGradient
          id="paint4_radial_6152_24427"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(63.5001 64.5) rotate(45) scale(25.8219)"
        >
          <stop />
          <stop offset="0.1452" stopColor="#0D0D0D" stopOpacity="0.848" />
          <stop offset="0.2686" stopColor="#2A2A29" stopOpacity="0.7189" />
          <stop offset="0.384" stopColor="#434242" stopOpacity="0.5981" />
          <stop offset="0.4946" stopColor="#5C5C5B" stopOpacity="0.4824" />
          <stop offset="0.6017" stopColor="#7B7A7A" stopOpacity="0.3702" />
          <stop offset="0.7063" stopColor="#9D9D9C" stopOpacity="0.2608" />
          <stop offset="0.8088" stopColor="#C3C3C2" stopOpacity="0.1535" />
          <stop offset="0.9072" stopColor="#EAEAEA" stopOpacity="0.0505" />
          <stop offset="0.9554" stopColor="white" stopOpacity="0" />
          <stop offset="0.9631" stopColor="#FDFDFD" stopOpacity="0.1719" />
          <stop offset="0.969" stopColor="#F6F6F6" stopOpacity="0.3034" />
          <stop offset="0.9742" stopColor="#EAEAEA" stopOpacity="0.4217" />
          <stop offset="0.9792" stopColor="#D9D9D9" stopOpacity="0.5321" />
          <stop offset="0.9838" stopColor="#C2C2C2" stopOpacity="0.637" />
          <stop offset="0.9883" stopColor="#A4A4A4" stopOpacity="0.7379" />
          <stop offset="0.9927" stopColor="#7F7F7E" stopOpacity="0.8355" />
          <stop offset="0.9968" stopColor="#504F4F" stopOpacity="0.9282" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_6152_24427"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(63.5001 64.4999) scale(23.801)"
        >
          <stop stopColor="#F0F0F0" stopOpacity="0.95" />
          <stop offset="1" stopColor="#E3E3E3" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_6152_24427"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(63.5004 64.5) scale(20.2446)"
        >
          <stop offset="0.8218" stopColor="#9D9D9C" />
          <stop offset="0.8349" stopColor="#A1A1A0" />
          <stop offset="0.8492" stopColor="#ACACAB" />
          <stop offset="0.8641" stopColor="#BDBDBD" />
          <stop offset="0.8663" stopColor="#C0C0C0" />
          <stop offset="0.9374" stopColor="#BFBFBF" />
          <stop offset="0.963" stopColor="#BABAB9" />
          <stop offset="0.9813" stopColor="#B0B0B0" />
          <stop offset="0.996" stopColor="#A2A2A2" />
          <stop offset="1" stopColor="#9D9D9C" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_6152_24427"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(63.5002 64.5004) scale(17.2201)"
        >
          <stop stopColor="#F0F0F0" stopOpacity="0.95" />
          <stop offset="1" stopColor="#E3E3E3" />
        </radialGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
